export const SEVERITY_OPTIONS = ['*', '**', '***'] as const;

export const DEFAULT_HARDCODED_SEVERITIES = [
  '***',
  '*',
  '**',
  '**',
  '**',
  '***',
  '***',
  '*',
  '**',
  '***'
];

export const formatSeverity = (severity?: string): string => {
  if (!severity) return '';
  const clean = severity.toString().trim().toUpperCase();
  switch (clean) {
    case 'LOW':
    case '1': return '*';
    case 'MEDIUM':
    case '2': return '**';
    case 'HIGH':
    case '3': return '***';
    default: return severity;
  }
};

export const getSeverityStars = (severity?: string): string => formatSeverity(severity);

export const severityToApiValue = (severity?: string | number): string => {
  const s = String(severity ?? '').trim().toUpperCase();
  switch (s) {
    case '*': case '1': return 'LOW';
    case '**': case '2': return 'MEDIUM';
    case '***': case '3': return 'HIGH';
    default: return s;
  }
};
